import React, { useEffect, useState } from "react";
import styled from "styled-components";
import UserServices from "../based/services/PartnerServices";
import AddProductModal from "./AddProductModal";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";
import Common from "../based/Common";
import TextNumber from "../based/inputs/TextNumber";
import Textbox from "../based/inputs/Textbox";

function ProductSection({ partnerId }) {
    const [partnerModel, setPartnerModel] = useState({});
    const [partnerCost, setPartnerCost] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);

    useEffect(() => {
        if (partnerId > 0) {
            getPartnerModel(partnerId);
            getPartnerCost(partnerId);
        }
    }, [partnerId]);

    const getPartnerModel = async (id) => {
        const [err, data] = await UserServices.GetPartnerModelById(id);
        if (!err && data) {
            setPartnerModel(data);
        } else {
            setPartnerModel({});
        }
    };

    const getPartnerCost = async (id) => {
        const [err, data] = await UserServices.GetPartnerCostById(id);
        if (!err && data) {
            setPartnerCost(data);
        } else {
            setPartnerCost([]);
        }
    };

    const updateTotal = async () => {
        const model = {
            partner: { ...partnerModel, partnerId: partnerId },
            listPartnerCost: partnerCost,
        };
        const [err, data] = await UserServices.UpdatePartnerTotalCost(model);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Cập nhật thành công");
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Cập nhật thất bại");
        }
    };

    return (
        <Wrapper>
            <section className="table-left">
                <div className="header-action">
                    <div className="left-action">
                        <span>Sản phẩm phôi</span>
                    </div>
                    <div className="right-action">
                        <button
                            className="btn btn-custom"
                            onClick={(e) => {
                                setShowAddModal(true);
                            }}
                        >
                            Thêm sản phẩm <i className="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>STT</th>
                            <th>Hình ảnh</th>
                            <th>Tên sản phẩm</th>
                            <th>Giá gốc</th>
                            <th>Giá cho Partner</th>
                        </tr>
                    </thead>
                    <tbody>
                        {partnerCost &&
                            partnerCost.map((item, idx) => {
                                return (
                                    <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td>
                                            <img src={item.productAvatar} alt="" />
                                        </td>
                                        <td>{item.productName}</td>
                                        <td>{Common.formatCurrency(item.productCost)}</td>
                                        <td>
                                            <TextNumber
                                                value={item.partnerCost}
                                                name={"partnerCost_" + idx}
                                                id={"partnerCost_" + idx}
                                                onChanged={(name, value) => {
                                                    let list = [...partnerCost];
                                                    list[idx].partnerCost = +value;
                                                    setPartnerCost(list);
                                                }}
                                                suffix="đ"
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </section>
            <section className="table-right">
                <div className="row-input-data">
                    <div className="form-group">
                        <label htmlFor="">Chi phí đóng gói</label>
                        <TextNumber
                            value={partnerModel.packageCost}
                            name="packageCost"
                            id="packageCost"
                            onChanged={(name, value) => {
                                setPartnerModel({ ...partnerModel, packageCost: +value });
                            }}
                            suffix="đ"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Chi phí vận chuyển</label>
                        <TextNumber
                            value={partnerModel.shippingFee}
                            name="shippingFee"
                            id="shippingFee"
                            onChanged={(name, value) => {
                                setPartnerModel({ ...partnerModel, shippingFee: +value });
                            }}
                            suffix="đ"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="">Chi phí ép Logo</label>
                        <TextNumber
                            value={partnerModel.logoPartnerCost}
                            name="logoPartnerCost"
                            id="logoPartnerCost"
                            onChanged={(name, value) => {
                                setPartnerModel({ ...partnerModel, logoPartnerCost: +value });
                            }}
                            suffix="đ"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Chi phí hộp</label>
                        <TextNumber
                            value={partnerModel.boxCost}
                            name="boxCost"
                            id="boxCost"
                            onChanged={(name, value) => {
                                setPartnerModel({ ...partnerModel, boxCost: +value });
                            }}
                            suffix="đ"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Chi phí giao ra bưu cục</label>
                        <TextNumber
                            value={partnerModel.deliverToPostOfficeCost}
                            name="deliverToPostOfficeCost"
                            id="deliverToPostOfficeCost"
                            onChanged={(name, value) => {
                                setPartnerModel({ ...partnerModel, deliverToPostOfficeCost: +value });
                            }}
                            suffix="đ"
                        />
                    </div>
                    <hr />
                    <div className="form-group">
                        <label htmlFor="">Thuế GTGT (Partner)</label>
                        <TextNumber
                            value={partnerModel.vat}
                            name="vat"
                            id="vat"
                            onChanged={(name, value) => {
                                setPartnerModel({ ...partnerModel, vat: value });
                            }}
                            suffix="%"
                            decimal
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Thuế TNCN (Partner)</label>
                        <TextNumber
                            value={partnerModel.personalTax}
                            name="personalTax"
                            id="personalTax"
                            onChanged={(name, value) => {
                                setPartnerModel({ ...partnerModel, personalTax: value });
                            }}
                            suffix="%"
                            decimal
                        />
                    </div>
                    <hr />
                    <div className="form-group">
                        <label htmlFor="">Thuế GTGT (Base Cost Tax)</label>
                        <TextNumber
                            value={partnerModel.baseCostVAT}
                            name="baseCostVAT"
                            id="baseCostVAT"
                            onChanged={(name, value) => {
                                setPartnerModel({ ...partnerModel, baseCostVAT: value });
                            }}
                            suffix="%"
                            decimal
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Thuế CIT (Base Cost Tax)</label>
                        <TextNumber
                            value={partnerModel.baseCostCIT}
                            name="baseCostCIT"
                            id="baseCostCIT"
                            onChanged={(name, value) => {
                                setPartnerModel({ ...partnerModel, baseCostCIT: value });
                            }}
                            suffix="%"
                            decimal
                        />
                    </div>
                    <hr />
                    <div className="form-group">
                        <label htmlFor="">Webhook Ding Url</label>
                        <Textbox
                            value={partnerModel.webhookDingUrl}
                            name="webhookDingUrl"
                            id="webhookDingUrl"
                            onChanged={(name, value) => {
                                setPartnerModel({ ...partnerModel, webhookDingUrl: value });
                            }}
                            placeholder="Nhập webhook ding url"
                        />
                    </div>
                </div>
            </section>
            <div className="bottom-button">
                <button
                    className="btn btn-custom"
                    onClick={(e) => {
                        updateTotal();
                    }}
                >
                    Hoàn thành
                </button>
            </div>
            <AddProductModal
                show={showAddModal}
                onClose={() => setShowAddModal(false)}
                partnerId={partnerId}
                onSave={() => {
                    setShowAddModal(false);
                    getPartnerCost(partnerId);
                }}
            />
        </Wrapper>
    );
}

export default ProductSection;

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .bottom-button {
        width: 100%;
    }

    td img {
        width: 100px;
        height: 100px;
        object-fit: contain;
    }
    section.partner-name {
        background: #fff;
        margin: 20px;
        padding: 24px;
        display: flex;
        align-items: center;
    }

    .partner-form {
        display: flex;
        flex-direction: column;
        margin: 0 12px;
    }

    section.partner-table {
        background: #fff;
        margin: 20px;
        padding: 24px;
        display: flex;
        flex-wrap: wrap;
    }

    .header-action {
        display: flex;
        align-items: center;
        margin: 12px 0;
    }

    .right-action {
        margin-left: auto;
    }

    section.table-left {
        margin-top: 20px;
    }

    section.table-left {
        width: 70%;
    }

    section.table-right {
        flex: 1;
        margin-top: 20px;
        margin-left: 120px;
    }

    ul.nav.nav-tabs.tabs-bordered {
        width: 100%;
    }

    .row-input-data .form-group {
        display: flex;
        flex-direction: column;
        margin: 12px 0;
    }

    .row-input-data .form-group input[type="text"] {
        border: 1px solid #d9d9d9;
        background: #fff;
        padding: 5px;
    }
`;
